
import React, { useState, useEffect } from "react";
import { fetchAllCategory } from "@/services/categoryApi";
import { useUser } from "@/context/UserContext";
import { useAppContext } from "@/context/Context";
import ProfileIncompleteModal from "../ProfileIncompleteModal/Modal";
import styles from "./OnlineSchoolForm.module.css";

const OnlineSchoolForm = () => {
  const { user } = useUser();
  const { isLightTheme } = useAppContext();

  const [focusedInput, setFocusedInput] = useState(null);
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    studentName: "",
    studentEmail: "",
    categoryId: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const isProfileComplete = user?.profileComplete ?? true;

  useEffect(() => {
    const loadcategories = async () => {
      try {
        const data = await fetchAllCategory();
        setCategories(data.data);
      } catch (err) {
        console.error("Error in fetching categories:", err);
      }
    };
    loadcategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isProfileComplete) {
      setShowModal(true);
      return;
    }

    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const payload = { ...formData };

      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/student-enquiry`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(
          "Your enquiry has been submitted successfully! Our team will contact you soon."
        );
        setFormData({
          studentName: "",
          studentEmail: "",
          categoryId: "",
          message: "",
        });
      } else {
        setErrorMessage(data.message || "Failed to submit enquiry.");
      }
    } catch (error) {
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      setTimeout(() => {
        setSuccessMessage("");
        setErrorMessage("");
      }, 3000);
    }
  };

  return (
    <>
      <div
        className={`${styles.formCard} ${styles.form} ${!isLightTheme ? styles.dark : ""
          }`}
      >
        <h3 className={styles.formTitle}>Looking For Internship?</h3>

        {successMessage && (
          <div className="alert alert-success mb-3">{successMessage}</div>
        )}
        {errorMessage && (
          <div className="alert alert-danger mb-3">{errorMessage}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div
            className={`${styles.formGroup} ${focusedInput === "name" ? styles.focused : ""
              }`}
          >
            <input
              name="studentName"
              type="text"
              placeholder="Name"
              value={formData.studentName}
              onChange={handleChange}
              onFocus={() => setFocusedInput("name")}
              onBlur={() => setFocusedInput("")}
              required
            />
          </div>

          <div
            className={`${styles.formGroup} ${focusedInput === "email" ? styles.focused : ""
              }`}
          >
            <input
              name="studentEmail"
              type="email"
              placeholder="Email"
              value={formData.studentEmail}
              onChange={handleChange}
              onFocus={() => setFocusedInput("email")}
              onBlur={() => setFocusedInput("")}
              required
            />
          </div>

          <div
            className={`${styles.formGroup} ${focusedInput === "category" ? styles.focused : ""
              }`}
          >
            <select
              name="categoryId"
              value={formData.categoryId}
              onChange={handleChange}
              onFocus={() => setFocusedInput("category")}
              onBlur={() => setFocusedInput("")}
              required
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <div
            className={`${styles.formGroup} ${focusedInput === "message" ? styles.focused : ""
              }`}
          >
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              onFocus={() => setFocusedInput("message")}
              onBlur={() => setFocusedInput("")}
              required
            ></textarea>
          </div>

          <button type="submit" className={styles.btnSubmit} disabled={loading}>
            {loading ? "SUBMITTING..." : "GET IT NOW →"}
          </button>
        </form>
      </div>

      <ProfileIncompleteModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default OnlineSchoolForm;
